<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-ip`]" width="1em" height="1em" v-bind="$attrs"><path d="M73.4313552,23.5201074 C75.0610774,24.6206131 76.4567672,26.0329183 77.5379099,27.6755497 L118.953003,85.6977462 C123.487324,92.5860029 121.651597,101.891749 114.846449,106.482291 C112.423336,108.120782 109.565757,108.997549 106.640672,109 L23.8007077,109 C15.6267083,109 9,102.290183 9,94.0110752 C9,91.053378 9.86530975,88.1592346 11.4859323,85.7001905 L52.9034702,27.6755497 C57.437791,20.7872929 66.6286517,18.9271214 73.4313552,23.5201074 Z M58,56 L49,56 L49,84 L58,84 L58,56 Z M78.5273312,56 L64,56 L64,84 L72.778135,84 L72.778135,73.6098226 L77.562701,73.6098226 C81.0868167,73.6098226 83.7073955,72.8140064 85.4244373,71.2223738 C87.1414791,69.6307412 88,67.4215553 88,64.5948158 C88,61.8444748 87.2122186,59.7244202 85.6366559,58.2346521 C84.0610932,56.744884 81.6913183,56 78.5273312,56 Z M75.266881,61.691678 C76.9003215,61.691678 78.0128617,61.9972715 78.6045016,62.6084584 C79.1961415,63.2196453 79.4919614,63.9645293 79.4919614,64.8431105 C79.4919614,65.7471578 79.1511254,66.4888586 78.4694534,67.0682128 C77.7877814,67.6475671 76.6045016,67.9372442 74.9196141,67.9372442 L72.778135,67.9372442 L72.778135,61.691678 Z" :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'" fill-rule="nonzero"/></svg>
</template>
<script>

export default {
  name: 'IconPsmIp',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
